import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "icon icon-rule" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "icon icon-record" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon icon-key" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "icon icon-agent" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "icon icon-power-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_switch_control = _resolveComponent("switch-control")

  return (_openBlock(), _createBlock("div", {
    class: ["setting-dialog-view-root", { 'mobile-d': _ctx.device.display === 1 }],
    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$emit('on-close')), ["self"]))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: ["menu", { desktop: _ctx.device.display !== 1 }],
        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode("div", {
          class: "menu-item",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.OnClickRules && _ctx.OnClickRules(...args)))
        }, [
          _hoisted_2,
          _createTextVNode(_toDisplayString(_ctx.iN('setting.rule')), 1)
        ]),
        _createVNode("div", {
          class: "menu-item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.OnCLickHistory()))
        }, [
          _hoisted_3,
          _createTextVNode(_toDisplayString(_ctx.iN('setting.betrecord')), 1)
        ]),
        _createVNode("div", {
          class: "menu-item",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.OnClickChangePassword && _ctx.OnClickChangePassword(...args)))
        }, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_ctx.iN('setting.changepassword')), 1)
        ]),
        _createVNode("div", {
          class: "menu-item",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.OnClickCustumerService()))
        }, [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_ctx.iN('setting.customerservice')), 1)
        ]),
        _createVNode(_component_switch_control, {
          class: "switch-control",
          label: _ctx.iN('setting.soundeffect'),
          value: _ctx.soundEffect,
          onChangeValue: _ctx.OnChangeSoundConfig
        }, null, 8, ["label", "value", "onChangeValue"]),
        _createVNode("div", {
          class: "menu-item",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ClickLogOut()))
        }, [
          _hoisted_6,
          _createTextVNode(_toDisplayString(_ctx.iN('setting.signout')), 1)
        ])
      ], 2)
    ])
  ], 2))
}